import React, { Component } from "react";

import { connect } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { getProductInventory } from "../../../../store/reducers/store";

class QuantityBoxDialog extends Component {
  state = { modalQuantity: this.props.choiceSelectedAmount };
  editQuantity = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const {
      option,
      choice,
      optionSelectedAmount,
      choiceSelectedAmount,
      productQuantity,
      usedComponents,
      productUsedComponents,
      editedProduct,
      groupID,
    } = this.props;
    let modalQuantity = this.state.modalQuantity;
    if (modalQuantity == choiceSelectedAmount) {
      this.props.closeModal();
      return;
    }
    let modifierDivider = 1;
    let choiceInventory = null;
    if (choice.related_product && choice.inventory !== null) {
      modifierDivider = productQuantity.quantity;
      const totalUsedComponents = { ...usedComponents };
      const modifierQuantity =
        (!option.quantity_exclusive &&
          choiceSelectedAmount * productQuantity.quantity) ||
        choiceSelectedAmount;
      if (choice.related_product.type_of_product === "stocked") {
        totalUsedComponents[choice.related_product.id] =
          (totalUsedComponents[choice.related_product.id] || 0) -
          modifierQuantity;
      } else if (choice.related_product.type_of_product === "composite") {
        Object.entries(choice.related_product.components).forEach(
          ([productId, product]) => {
            totalUsedComponents[productId] =
              (totalUsedComponents[productId] || 0) -
              modifierQuantity * product.required_amount;
          }
        );
      }

      Object.entries(editedProduct?.prevUsedComponents || {}).forEach(
        ([optionId, optionQuantity]) => {
          const newOptionId = optionId.toString().replace("Q", "");
          totalUsedComponents[newOptionId] =
            (totalUsedComponents[newOptionId] || 0) -
            optionQuantity *
              ((optionId.toString().includes("Q") && 1) ||
                editedProduct.quantity);
        }
      );
      Object.entries(productUsedComponents).forEach(
        ([productId, optionQuantity]) => {
          const newProductId = productId.toString().replace("Q", "");
          totalUsedComponents[newProductId] =
            (totalUsedComponents[newProductId] || 0) +
            optionQuantity *
              ((productId.toString().includes("Q") && 1) ||
                productQuantity.quantity);
        }
      );
      choiceInventory = getProductInventory(
        choice.related_product,
        totalUsedComponents
      );
    }
    const optionMaximum = option.maximum || Infinity;
    const choiceMaximum = Math.min(
      choice.maximum || Infinity,
      (choiceInventory !== null &&
        parseInt(choiceInventory / modifierDivider)) ||
        Infinity
    );
    let optionAmountLeft = Math.min(
      optionMaximum - optionSelectedAmount,
      choiceMaximum - choiceSelectedAmount
    );
    let choiceAmountDifference = modalQuantity - choiceSelectedAmount;

    choiceAmountDifference = Math.min(choiceAmountDifference, optionAmountLeft);
    this.props.controlOptions(option, choice, choiceAmountDifference, groupID);

    this.props.closeModal();
  };

  render() {
    const { choiceSelectedAmount } = this.props;
    return (
      <Dialog
        onClick={(e) => {
          e.stopPropagation();
        }}
        onClose={(e) => {
          e.stopPropagation();
          this.props.closeModal();
        }}
        open={true}
      >
        <DialogContent>
          <form noValidate autoComplete="off" onSubmit={this.editQuantity}>
            <TextField
              inputProps={{
                className: "text-center",
              }}
              autoFocus
              fullWidth
              margin="dense"
              type="number"
              variant="outlined"
              onChange={(e) => {
                this.setState({
                  modalQuantity: e.target.value.replace("-", ""),
                });
              }}
              defaultValue={choiceSelectedAmount || undefined}
            />
            <Button
              className={`my-1  mx-auto`}
              variant="contained"
              color="primary"
              type="submit"
              style={{
                boxShadow: "none",
                width: "100%",
                textTransform: "none",
              }}
              dir={this.props.language == "english" ? "ltr" : "rtl"}
            >
              {this.props.language === "arabic" ? "إتمام" : "Ok"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    usedComponents: state.store.used_components,
  };
};

export default connect(mapStateToProps)(QuantityBoxDialog);
